import React, { useRef } from 'react';
import styled from 'styled-components';
import tw from 'tailwind.macro';
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

export default ({
  onChange, onInput, setAddress, address, className,
}) => {
  const inputRef = useRef();
  const handleSelect = async (address) => {
    setAddress(address);
    try {
      const results = await geocodeByAddress(address);
      const coordinates = await getLatLng(results[0]);

      // Loose focus on input after select address
      inputRef.current.blur();

      onChange(coordinates);
    } catch (err) {
      console.error(err);
    }
  };

  // On click address input, select all (easier to modify)
  const onClick = () => {
    inputRef.current.select();
  };

  const searchOptions = {
    componentRestrictions: {
      country: 'cl',
    },
  };

  return (
    <PlacesAutocomplete
      value={address}

      onChange={onInput}
      onSelect={handleSelect}
      searchOptions={searchOptions}
      googleCallbackName="callbackAutocomplete"
      className={className}
    >
      {({
        getInputProps, suggestions, getSuggestionItemProps, loading,
      }) => (
        <Container>
          <Icon>
            <FontAwesomeIcon icon={faSearch} />
          </Icon>

          <Input
            ref={inputRef}
            onClick={onClick}
            placeholder="Ingresar tu dirección aquí"
            {...getInputProps()}
          />
          <DropdownContainer>
            {/* {loading && <div>Loading...</div>} */}
            {suggestions.map((suggestion) => (
              <Suggestion
                active={suggestion.active}
                {...getSuggestionItemProps(suggestion)}
              >
                <span>{suggestion.description}</span>
              </Suggestion>
            ))}
          </DropdownContainer>
        </Container>
      )}
    </PlacesAutocomplete>
  );
};

const Container = styled.div`
  ${tw`flex-1 w-full relative`}
`;

const Icon = styled.div`
  color: #7BBC57;
  ${tw`
    absolute mt-3 ml-4
  `}
`;

const Input = styled.input`
  box-sizing: border-box;
  color: #5c5c5c;
  background-color: #F0F0F0;
  ${tw`
    w-full border-none pl-10 pr-6 text-base py-3 outline-none
    rounded-full
  `}

  @media (min-width: 768px) {
    ${tw`
      mt-0 text-sm
    `};
  }
`;

const DropdownContainer = styled.div`
  ${tw`text-left absolute bg-white mt-2 rounded-lg mx-4 pr-10 shadow-lg z-50`}
`;

const Suggestion = styled.div`
  transition: color .3s ease;
  color: #A2A2A2;
  ${tw`py-2 pl-4 pr-2 my-1 text-base cursor-pointer`}
  :hover {
    color: #666666;
  }

  @media (min-width: 768px) {
    ${tw`
      text-xs
    `};
  }
`;
